<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="820px">
    <el-form label-width="50" inline class="elementui-common-form-styles">
      <el-form-item label="创建人">
        <ThrottleSelector
          :popper-append-to-body="false"
          v-model="opId"
          @change="newQuery"
          @on-clear="newQuery"
          :list="sysUsers"
          style="width: 120px"
          placeholder="全部"
          filterable
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-input v-model.trim="keyword" placeholder="输入批量模板名称" style="width: 200px" @keyup.enter.native="newQuery">
          <i slot="append" @click="newQuery" class="el-icon-search"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <el-table v-loading="tableLoading" ref="ref_MultipleTable" height="350" border :data="accountList" style="width: 100%">
      <el-table-column label="模板名称" width="220">
        <template slot-scope="{ row }">
          <div class="template-name-row">
            <span>{{ row.name }}</span>
            <em class="el-icon-edit icon" @click="emits('update-title', row)"></em>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="描述" width="120">
        <template slot-scope="{ row }">
          <div class="template-name-row">
            <span>{{ row.remark }}</span>
            <em class="el-icon-edit icon" @click="emits('update-title', row)"></em>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="opName" label="新建人员" width="130"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="{ row }">
          <div>
            {{ row.createTime | datetimeToSec }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="checkTemplate(row)">选择</el-button>
          <el-button type="text" @click="deleteTemplate(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageInfo.current"
        :pager-count="5"
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="pageInfo.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total"
      >
      </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script setup>
import { reactive, ref, inject, computed, nextTick } from 'vue'
import { getQueryConditionByPage, delQueryCondition } from '@/api/ptom.data.model'
import { PTOM_USERS, initPageData } from '@/data/global-opts'
import { MessageBox, Message } from 'element-ui'
import ThrottleSelector from '@/components/throttle-select/index.vue'
const PAGE_REQUIRED_OPTS = initPageData([PTOM_USERS])
// eslint-disable-next-line
const { title, menuId } = defineProps({
  title: String,
  menuId: String
})
// eslint-disable-next-line
const emits = defineEmits(['confirm', 'update-title'])
const { opId: defaultOpId } = inject('localStates')

const opId = ref(defaultOpId)
const keyword = ref('')
const dialogVisible = ref(false)
const tableLoading = ref(false)
const accountList = ref([])
const pageInfo = reactive({
  current: 1,
  size: 10,
  total: 0
})
const sysUsers = computed(PAGE_REQUIRED_OPTS.PTOM_USERS)
const open = () => {
  pageInfo.current = 1
  getData(buildParams())
  dialogVisible.value = true
}
const close = () => {
  dialogVisible.value = false
}
const buildParams = () => {
  const params = {
    pageIndex: pageInfo.current,
    pageSize: pageInfo.size,
    createOpId: opId.value,
    keyword: keyword.value
  }
  return params
}
const newQuery = () => {
  nextTick(() => {
    getData(buildParams())
  })
}
const handleSizeChange = (size) => {
  getData(buildParams())
}
const handleCurrentChange = (current) => {
  getData(buildParams())
}
const getData = async (params) => {
  try {
    tableLoading.value = true
    const { list, page_info } = await getQueryConditionByPage({ ...params, menuId })
    accountList.value = list
    pageInfo.total = page_info.total_number
    tableLoading.value = false
  } catch (e) {
    console.log(e)
    tableLoading.value = false
  }
}
const checkTemplate = (row) => {
  emits('confirm', row)
  close()
}
const deleteTemplate = async (row) => {
  try {
    MessageBox.confirm('此操作将永久删除该模板, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async () => {
        tableLoading.value = true
        const result = await delQueryCondition({ id: row.id })
        getData(buildParams())
        Message({
          type: 'success',
          message: '删除成功!'
        })
      })
      .catch(() => {
        Message({
          type: 'info',
          message: '已取消删除'
        })
      })
  } catch (e) {
    console.log(e)
    tableLoading.value = false
  }
}
// eslint-disable-next-line
defineExpose({
  open,
  close
})
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 20px;
}
.pagination-box {
  margin-top: 10px;
}

::v-deep .template-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon {
    cursor: pointer;
  }
}
</style>
